import Vue from 'vue'
import ElementUI from 'element-ui';
import {Message} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './request/http'
import i18n from './i18n/index'
Vue.use(ElementUI);


import './style/global.scss'
Vue.prototype.axios = axios;
Vue.prototype.$message = Message
// if (process.env.VUE_APP_MOCK) {
//   require('./mock/mock.js')
// }

Vue.config.productionTip = false
new Vue({
  i18n,
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')
